import GradientHeader from './shared/GradientHeader';
import React from 'react';
import { useUserContext } from 'UserContext';
import DoYouKnowTheDates from './businessSteps/doYouKnowDates/DoYouKnowTheDates';
import RoleOptions from './businessSteps/roleOptions/RoleOptions';
import ShortOrLongTerm from './businessSteps/shortOrLongTerm/ShortOrLongTerm';
import { OnboardingContextProvider, OnboardingStep, useOnboardingContext } from './OnboardingContext';

function Steps() {
    const { user } = useUserContext();
    const { currentStep } = useOnboardingContext();
    const headers: { [key in OnboardingStep]: string } = {
        [OnboardingStep.ShortOrLongTerm]: `Welcome, ${user?.first_name}! What type of position would you like to fill?`,
        [OnboardingStep.DoYouKnowTheDates]: 'Great! Do you know the dates you need help?',
        [OnboardingStep.Role]: 'We can help! Do you have a role in mind?',
    };
    const steps: { [key in OnboardingStep]: React.ReactNode } = {
        [OnboardingStep.ShortOrLongTerm]: <ShortOrLongTerm />,
        [OnboardingStep.DoYouKnowTheDates]: <DoYouKnowTheDates />,
        [OnboardingStep.Role]: <RoleOptions />,
    };
    return (
        <>
            <GradientHeader>{headers[currentStep]}</GradientHeader>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>{steps[currentStep]}</div>
        </>
    );
}

export default function Onboarding() {
    return (
        <OnboardingContextProvider>
            <Steps />
        </OnboardingContextProvider>
    );
}
